import { render, staticRenderFns } from "./StopWatch.vue?vue&type=template&id=36950f2c&scoped=true&"
import script from "./StopWatch.vue?vue&type=script&lang=js&"
export * from "./StopWatch.vue?vue&type=script&lang=js&"
import style0 from "./StopWatch.vue?vue&type=style&index=0&id=36950f2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36950f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36950f2c')) {
      api.createRecord('36950f2c', component.options)
    } else {
      api.reload('36950f2c', component.options)
    }
    module.hot.accept("./StopWatch.vue?vue&type=template&id=36950f2c&scoped=true&", function () {
      api.rerender('36950f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/StopWatch.vue"
export default component.exports